module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Auswahl Marken",
      "autocomplete": "",
      "loading": _vm.loading,
      "dark": "",
      "multiple": "",
      "cache-items": "",
      "chips": "",
      "required": "",
      "items": _vm.marken,
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      "search-input": _vm.search
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      }
    },
    model: {
      value: (_vm.fa.marken),
      callback: function($$v) {
        _vm.$set(_vm.fa, "marken", $$v)
      },
      expression: "fa.marken"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "offset-xs1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fa.marken), function(marke, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs6": ""
      }
    }, [_c('p', [_c('strong', [_vm._v(" " + _vm._s(marke.name) + " ")])]), _vm._v(" "), _c('v-avatar', {
      attrs: {
        "tile": ""
      }
    }, [_c('img', {
      staticClass: "dragLogo",
      attrs: {
        "src": _vm.markenlogo(marke.logos[0].dateiserverpfad)
      }
    })])], 1)
  }))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32667c27","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/markenSelect.vue
// module id = 319
// module chunks = 0